import { ROUTES } from '@/constants/routeConstants'
import { CreateOrganizationView } from '@/features/onboarding/create-organization-view'
import { PendingApprovalView } from '@/features/onboarding/pending-approval-view'
import { useOrganizationStore } from '@/store/organization'
import { Navigate } from '@tanstack/react-router'

/**
 * Main onboarding component that handles both organization creation and pending approval.
 * Shows the appropriate view based on the organization status.
 */
export const Onboarding = () => {
  const organization = useOrganizationStore((s) => s.organization)
  const isLoading = useOrganizationStore((s) => s.isLoading)

  const isPendingApproval = organization?.account_status === 'pending_approval'

  if (isLoading) {
    return null
  }

  if (!organization) {
    return <CreateOrganizationView />
  }

  // If user has an organization and it's pending approval, show pending view
  if (isPendingApproval) {
    return <PendingApprovalView />
  }

  return <Navigate to={ROUTES.HOME} replace={true} />
}
